export default "__VITE_ASSET__Bmfc2cdV__"